import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import * as AOS from 'aos';
import { TK_CONFIG, Config, AcceptJSService, CreditCard } from '@openutility/acceptjs-angular-wrapper';
import { Subscription } from 'rxjs/internal/Subscription';
import { Meta, Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  private popupOpenSubscription: Subscription;
  private popupCloseSubscription: Subscription;
  private initializeSubscription: Subscription;
  private statusChangeSubscription: Subscription;
  private revokeChoiceSubscription: Subscription;
  private noCookieLawSubscription: Subscription;

  showScrol = false
  constructor(private router: Router, private _acceptJSSrv: AcceptJSService, private meta: Meta) {
    setTimeout(() => { AOS.refresh(); }, 500);
    this.router.events.subscribe(event => {
      if (event.constructor.name === "NavigationEnd") {
        if (router.url == '/') {
          this.showScrol = true
        } else {
          this.showScrol = false
        }
      }
    });
  }
  setSEO() {
    this.meta.updateTag({
      name: 'description',
      content: 'Titanium Comms offers secure, encrypted, and quantum-resistant messaging and conferencing solutions.'
    });
  
    this.meta.updateTag({
      name: 'keywords',
      content: "titanium comms, quantum resistant encryption, quantum encryption, encrypted communications, encrypted messaging, end-to-end encryption, secure communications, private communications, secure messaging, private messaging, secure conferencing, messaging, conferencing, meetings, conversations, communications, conference, messaging"
    });
  }
  
  async onSubmit(cc: CreditCard): Promise<void> {
    try {
      const nonce = await this._acceptJSSrv.generatePaymentNonce(cc);
    } catch (ex) {
      console.error(ex);
    }
  }

  index = 1
  section = ['container', 'section', 'second-grid-img', 'section3', 'section4']

  ngOnInit() {
    AOS.init({
      delay: 100,
      debounceDelay: 50,
      once: true,
      mirror: true,

    });
  }

  ngOnDestroy() {
    this.popupOpenSubscription.unsubscribe();
    this.popupCloseSubscription.unsubscribe();
    this.initializeSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
    this.revokeChoiceSubscription.unsubscribe();
    this.noCookieLawSubscription.unsubscribe();
  }
  

  scrollTo(className: string): void {
    if (this.index == 5) {
      this.index = 1

      const elementList = document.querySelectorAll('.' + 'video-wrapper');
      const element = elementList[0] as HTMLElement;
      element.scrollIntoView({ behavior: 'smooth' });
    } else {

      const elementList = document.querySelectorAll('.' + this.section[this.index]);
      const element = elementList[0] as HTMLElement;
      element.scrollIntoView({ behavior: 'smooth' });
      this.index = this.index + 1
    }

  }
}
